import imageCompression from "browser-image-compression";

const MAX_FILE_SIZE = 1024 * 1024;
const MAX_GIF_SIZE = 600 * 1024;

export function validateImageFile(file) {
  if (!file) return { valid: false, message: "No file selected." };
  const limit = file.type === "image/gif" ? MAX_GIF_SIZE : MAX_FILE_SIZE;
  if (file.size > limit) {
    const mb = (file.size / (1024 * 1024)).toFixed(2);
    const maxMb = (limit / (1024 * 1024)).toFixed(2);
    return { valid: false, message: `File too large (${mb} MB). Maximum is ${maxMb} MB.` };
  }
  return { valid: true, message: "" };
}

export async function compressImageFile(file, maxDimension = 200, quality = 0.8) {
  if (file.type === "image/gif") {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  }

  let compressed;
  try {
    compressed = await imageCompression(file, {
      maxSizeMB: 0.3,
      maxWidthOrHeight: maxDimension * 2,
      useWebWorker: true,
    });
  } catch {
    compressed = file;
  }

  const mime = file.type || "image/png";

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let w = img.width, h = img.height;
      if (w > maxDimension || h > maxDimension) {
        const ratio = Math.min(maxDimension / w, maxDimension / h);
        w = Math.round(w * ratio);
        h = Math.round(h * ratio);
      }
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      const output = canvas.toDataURL(mime, quality);
      URL.revokeObjectURL(url);
      resolve(output);
    };
    const url = URL.createObjectURL(compressed);
    img.src = url;
    img.onerror = () => {
      URL.revokeObjectURL(url);
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(compressed);
    };
  });
}
